import { OpenInNew } from "@mui/icons-material";
import LinkConstants from "../../../../constants/LinkConstants";
import { POSTHOG_EVENTS } from "../../../../constants/PostHogEvents";
import RouterConstants from "../../../../constants/RouterConstants";
import usePostHog from "../../../../hooks/usePostHog";
import BriaButton from "../../BriaButton/BriaButton";
import BriaButtonGroup from "../../BriaButtonGroup/BriaButtonGroup";
import styles from "../ApiReferenceDialog.module.scss";

const ApiReferenceDialogFooter = () => {
	const { trackEvent } = usePostHog();

	const handleApiDocClick = () => {
		trackEvent(POSTHOG_EVENTS.API_REFERENCE_DOCUMENTATION_CLICKED);
		window.open(LinkConstants.IMAGE_GENERATION.FIBO.DOCS, "_blank");
	};

	const handleGetApiKeyClick = () => {
		trackEvent(POSTHOG_EVENTS.API_REFERENCE_GET_API_KEY_CLICKED);
		window.open(RouterConstants.AUTH_KEYS.fullPath, "_blank");
	};

	return (
		<BriaButtonGroup className={styles.footerButtons}>
			<BriaButton
				startIcon={<OpenInNew />}
				buttonType="textMedium"
				onClick={handleApiDocClick}
				className={styles.footerButton}
			>
				API Documentation
			</BriaButton>
			<BriaButton
				startIcon={<OpenInNew />}
				buttonType="primaryMedium"
				onClick={handleGetApiKeyClick}
				className={styles.apiButton}
			>
				Get API Key
			</BriaButton>
		</BriaButtonGroup>
	);
};

export default ApiReferenceDialogFooter;
